/** Client for the release center API (task 4130.9). */
import { apiFetch } from "../../app/api";

const BASE = "/api/v1/release";

export interface BatchRow {
  id: string;
  batch_key: string;
  release_state: string;
  purpose: string;
  interface: string;
  item_count: number | null;
}

export interface BatchView {
  batch: BatchRow;
  manifest_sha256: string | null;
  manifest_version: number | null;
  preflight: { check_code: string; outcome: string; reason: string | null }[];
  receipts: {
    items: number;
    counts: Record<string, number>;
    statuses: {
      release_item_id: string;
      item_seq: number;
      target_object: string;
      outcome: string;
      destination_id: string | null;
      error: string | null;
      value_changed: boolean;
    }[];
  };
  population: Record<string, number>;
  verification: {
    release_item_id: string | null;
    holdback_id: string | null;
    verification_method: string;
    outcome: string;
    details: { detail?: string };
  }[];
}

export function message(caught: unknown): string {
  return caught instanceof Error ? caught.message : String(caught);
}

export function listBatches(engagementId: string): Promise<BatchRow[]> {
  return apiFetch<BatchRow[]>(`${BASE}/batches?engagement_id=${encodeURIComponent(engagementId)}`);
}

export function getBatch(batchId: string): Promise<BatchView> {
  return apiFetch<BatchView>(`${BASE}/batches/${encodeURIComponent(batchId)}`);
}
